define("shared/components/shared/social-identity/placeholder-item", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "later/utils/constants", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _constants, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"later/utils/constants",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div ...attributes class="cSS--set__item {{if @selectable 'cSS--set__item--dashed'}}">
    <div
      class="o--user cSS--user qa--empty_social_slot"
      data-test-id="social profile placeholder"
      {{! template-lint-disable no-invalid-interactive }}
      {{on "click" this.toggleSelect}}
    >
      <span
        class="o--user__avatar cSS--user__avatar--empty cSS--user__avatar--{{@platform}}
          {{if @selectable 'is--selectable'}}"
        data-test-id="placeholder avatar"
      >
      </span>
    </div>
  </div>
  */
  {
    "id": "Fc9CW3sa",
    "block": "[[[11,0],[17,1],[16,0,[29,[\"cSS--set__item \",[52,[30,2],\"cSS--set__item--dashed\"]]]],[12],[1,\"\\n  \"],[11,0],[24,0,\"o--user cSS--user qa--empty_social_slot\"],[24,\"data-test-id\",\"social profile placeholder\"],[4,[38,1],[\"click\",[30,0,[\"toggleSelect\"]]],null],[12],[1,\"\\n    \"],[10,1],[15,0,[29,[\"o--user__avatar cSS--user__avatar--empty cSS--user__avatar--\",[30,3],\"\\n        \",[52,[30,2],\"is--selectable\"]]]],[14,\"data-test-id\",\"placeholder avatar\"],[12],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"&attrs\",\"@selectable\",\"@platform\"],false,[\"if\",\"on\"]]",
    "moduleName": "shared/components/shared/social-identity/placeholder-item.hbs",
    "isStrictMode": false
  });
  /**
   * @class PlaceholderItem
   *
   * @extends Component
   */
  let PlaceholderItemComponent = _exports.default = (_class = class PlaceholderItemComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "cache", _descriptor, this);
    }
    get socialIdentityId() {
      return this.args.properties?.socialIdentity?.id || '0';
    }
    toggleSelect() {
      if (this.args.toggleSelect) {
        if (this.args.platform === _constants.SOCIAL_PROFILE_CODES.LINKEDIN) {
          this.cache.add('linkedin_selected_social_identity_id', this.socialIdentityId, {
            expiry: this.cache.maxExpiryDate(),
            persist: true
          });
        }
        this.args.toggleSelect(this.args.properties);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "toggleSelect", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSelect"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PlaceholderItemComponent);
});